import { render, staticRenderFns } from "./AllJournal.vue?vue&type=template&id=20aa02aa"
import script from "./AllJournal.vue?vue&type=script&lang=js"
export * from "./AllJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports